import { render, staticRenderFns } from "./FrameHead.vue?vue&type=template&id=0b4b6171&scoped=true"
import script from "./FrameHead.vue?vue&type=script&lang=js"
export * from "./FrameHead.vue?vue&type=script&lang=js"
import style0 from "./FrameHead.vue?vue&type=style&index=0&id=0b4b6171&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4b6171",
  null
  
)

export default component.exports